import Section from '@components/atoms/Section';
import Spacing from '@components/atoms/Spacing';
import { Heading1 } from '@components/atoms/Typography';
import BreadCrumbs from '@components/molecules/BreadCrumbs';
import GridLinkList from '@components/molecules/list/GridLinkList';
import PageContainer from '@components/molecules/PageContainer';
import BREAKPOINTS from '@lib/constants/breakpoints';
import ROUTES from '@lib/constants/routes';
import stats from '@lib/data/stats';
import { GetStaticPaths, GetStaticProps } from 'next';
import { useRouter } from 'next/router';
import React from 'react';
import styled from 'styled-components';

interface Props {
  models: string[];
  brand: string;
}

const Header = styled(Section)`
  padding-top: 120px;

  @media screen and (max-width: ${BREAKPOINTS.medium}) {
    padding-top: 50px;
  }
`;

const BrandStats = ({ models, brand }: Props) => {
  const router = useRouter();

  if (router.isFallback) return <PageContainer loading />;

  const links = [
    {
      label: 'Luna',
      href: '/',
    },
    {
      label: 'Ficha técnica',
      href: `${ROUTES.stats.home}`,
    },
    {
      label: 'Motos',
      href: `${ROUTES.stats.type({ type: 'motos' })}`,
    },
    {
      label: `${brand}`,
      href: `${ROUTES.stats.brand({ brand, type: 'motos' })}`,
    },
  ];

  return (
    <PageContainer
      title={`Ficha técnica - Modelo da ${brand}`}
      metaDescription={`Ficha técnica com as especificações completas da ${brand}. Veja detalhes de motor, performance, valores, seguro e muito mais nesse guia!`}
    >
      <Header>
        <Heading1>
          Modelos da
          {` ${brand}`}
        </Heading1>
        <Spacing top={2}>
          Todas as fichas técnicas de modelos de motos da {brand}
        </Spacing>
      </Header>
      <Section>
        <GridLinkList
          links={models.map((s) => ({
            label: s,
            path: ROUTES.stats.model({ brand, model: s, type: 'motos' }),
          }))}
        />
      </Section>
      <Section style={{ paddingTop: 0 }}>
        <BreadCrumbs links={links} />
      </Section>
    </PageContainer>
  );
};

export const getStaticProps: GetStaticProps<Props> = async ({ params }) => {
  const brand = params?.brand?.toString() as string;

  const models = await stats.getVehiclesFromBrand(brand, 'motorcycle');

  if (!models.length) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      models,
      brand,
    },
  };
};

export const getStaticPaths: GetStaticPaths = async () => ({
  paths: ['/ficha-tecnica/motos/Honda'],
  fallback: true,
});

export default BrandStats;
